import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import styles from "./scss/hunttableview.module.scss";
import leftarr from "../../styles/images/leftpagination.svg";
import rightarr from "../../styles/images/rightpagination.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import nodeicon from "../../styles/images/rolesicon.svg";
import { Row, Col, Dropdown, Modal, Button, Form } from 'react-bootstrap';
import Select, { components } from 'react-select';
import Bulkclose from "../../styles/images/bulk_close.svg";
import ToastSuccess from '../toastSuccess';
import { API_ROUTE_CONTROLLER } from '../../app/base/routes';
import { ApiServices } from '../../app/base/service/apiService';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MarketingServices } from '../../service/marketingService';
import { sethuntgroup_adduser_1 } from "../../store/huntgroup";
import { MultiSelect } from "react-multi-select-component";
import moment from "moment";
import { BaseService } from '../../service/base';
import Loaders from '../loader';
import EmptyData from '../../styles/images/nodata.svg';

const bs = new BaseService();

const MoreSelectedBadge = ({ items }) => {
  const title = items.join(", ");
  const length = items.length;
  //const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;
  const label = `${length} selected`;
  return (
    <div title={title}>
      {label}
    </div>
  );
};

const MultiValue = (props:any) => {
  const maxToShow = 0;
  const overflow = props?.getValue()
    .slice(maxToShow)
    .map((x:any) => x.label);

  return props?.index < maxToShow ? (
    <components.MultiValue {...props} />
  ) : props?.index === maxToShow ? (
    <MoreSelectedBadge items={overflow} />
  ) : null;
};


const HuntGroupTable = () => {
  const [loader,setLoader] = useState<any>(false);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);

  const [enableShow, setenableShow] = useState(false);
  const enablehandClose = () => setenableShow(false);
  const enablehandShow = () => setenableShow(true);

  const [disableShow, setdisableShow] = useState(false);
  const disablehandClose = () => setdisableShow(false);
  const disablehandShow = () => setdisableShow(true);

  const [deleteShow, setdeleteShow] = useState(false);
  const deletehandClose = () => setdeleteShow(false);
  const deletehandShow = () => setdeleteShow(true);

  const [statusEnable, setStatusEnable] = useState(false);
  const statusEnableClose = () => setStatusEnable(false);
  const statusEnableShow = () => setStatusEnable(true);

  const [statusDisable, setStatusDisable] = useState(false);
  const statusDisableClose = () => setStatusDisable(false);
  const statusDisableShow = () => setStatusDisable(true);

  const navigate = useNavigate();
  const [modalShow, setmodalShow] = useState(false);
  const handleClose = () => setmodalShow(false);
  const handleShow = () => setmodalShow(true);
  const login = useSelector((state: any) => state.login.login);
  const [huntList, setHuntList] = useState<any>([]);
  const [getGroupID, setGroupID] = useState<any>("");

  const _login = useSelector((state: any) => state.login.login);
  const [status, setStatus] = useState(0);
  const [selected_ext, serExtnComma] = useState("");
  const [selected_count, selectedExtCount] = useState(0);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [createGroup, setCreateGroup] = useState(false);
  const [bulkgrpid, bulkGroupid] = useState<any>([]);
  const [isSelect, setisSelect] = useState<any>('');
  const [toastHide, setToastHide] = useState('');
  const [length, setLength] = useState<any>('');
  const [grpStatus, setgrpStatus] = useState('');
  const dispatch = useDispatch<any>();
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [dateFilter, setDateFilter] = useState<any>(0);
  const [hoursFilter, setHoursFilter] = useState<any>(0);

  const [dateRanges, setDateRange] = useState<any>([null, null]);
  const [startDate, endDate] = dateRanges;
  const [getstartdate, setStartDate] = useState<any>("");
  const [getenddate, setEndDate] = useState<any>("");
  const [grpname,setGrpname] = useState<any>("");

  const btnEdit = (row:any) => {
    setGrpname(row.grp_name);    //console.log("rowrow---__", row);
    localStorage.setItem("_hunt_group_one", JSON.stringify(row));
    localStorage.setItem("grp_name", JSON.stringify(row.grp_name));
    //dispatch(sethuntgroup_adduser_1(""));
    navigate("/huntgroup/edithuntgroup");
  };

  const btnDelete = async (row:any) => {
    setGrpname(row.grp_name);
    if (window.confirm("Are you sure, do want to delete?")) {
      //const _res = await bulkAction(2, 0, row.grp_id);
      //console.log("_res_res", _res);
      setLoader(true);
      let _url = API_ROUTE_CONTROLLER.Urmyaccountbulkenabledelete;
      let _body = {
        "company_id": _login.company_id,
        "groupid_info": row.grp_id,
        "processtype": 2,
        "status": 0
      };

      await bs.post(_url,_body).then(async(ob)=>{
        await hubspot_hunt_status_update(2,0,row.grp_name);
        setLoader(false);
        window.location.reload();
      });
    }
  };

  const expandRow = {
    renderer: (row: any, index: any) => (
      <div id={index} className="expandtable">
        <ul>
        <li><span>Group Name :</span>{row.grp_name}</li>
        <li><span>Number :</span>{row.grp_did_display}</li>
        <li><span>Extension :</span>{row.group_extn} </li>
        <li><span>Call Distribution :</span>{row.call_distribution_desc}</li>
        <li><span>Status :</span>{row.status_desc} </li>
        <li><span>Action :</span>{row.actions} </li>
        {/* <p>View more</p> */}
        </ul>
      </div>
    ),
    showExpandColumn: true, expandColumnPosition: "center", expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>;
      }
      return <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>
        );
      }
      return (
        <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>
      );
    }
  };
  const [columns, setColumns] = useState([
    { dataField: 'grp_name', text: 'Group Name', sort: true },
    // { dataField: 'country', text: 'Location', sort: true },
    { dataField: 'grp_did_display', text: 'Number', sort: true },
    { dataField: 'group_extn', text: 'Extension', sort: true },
    { dataField: 'call_distribution_desc', text: 'Call Distribution', sort: true },
    {
      dataField: 'status_desc',
      formatter: (cell, row) => {
        return (
          <><><Form.Check type="switch" onClick={(e: any) => {setGrpname(row.grp_name); defaineShowModal(e.target.checked); setgrpStatus(row.grp_id) }} defaultChecked={row.status == 1 ? true : false} /></></>
        )
      },
      text: 'Status', sort: true
    },
    {
      dataField: 'actions',
      formatter: (cell, row) => {
        return (
          (row.status_desc == "Active") ?
            <>
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => btnEdit(row)}><path d="M12.4523 4.45177C12.3523 4.35177 12.2223 4.30177 12.0823 4.30177C11.9523 4.30177 11.8223 4.35178 11.7323 4.44178L0.962305 14.8818C0.772305 15.0718 0.652305 15.3318 0.652305 15.6018L0.612305 17.9818C0.612305 18.5418 1.0523 19.0118 1.6123 19.0118L3.9923 19.0518H4.01231C4.27231 19.0518 4.5323 18.9518 4.7223 18.7618L15.4923 8.32178C15.6923 8.12178 15.7023 7.80177 15.5023 7.60178L12.4523 4.45177Z" fill="#757676"></path><path d="M19.1023 3.42178L16.7323 0.981775C16.5323 0.781775 16.2723 0.681775 16.0123 0.681775L16.0223 0.671875C15.7723 0.671875 15.5223 0.761875 15.3223 0.951875L13.1323 3.07187C12.9423 3.25187 12.9323 3.56187 13.1223 3.75187L16.2123 6.94188C16.3023 7.04188 16.4323 7.09188 16.5623 7.09188C16.6923 7.09188 16.8023 7.04187 16.8923 6.95187L19.0823 4.83187C19.4823 4.45187 19.4923 3.81178 19.1023 3.42178Z" fill="#757676"></path></svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => btnDelete(row)}>
                <path d="M10.378 17.935C9.96392 17.935 9.62803 17.5991 9.62803 17.185V8.61525C9.62803 8.20115 9.96392 7.86525 10.378 7.86525C10.7921 7.86525 11.128 8.20115 11.128 8.61525V17.185C11.128 17.5991 10.7921 17.935 10.378 17.935Z" fill="#f22e57" />
                <path d="M13.6182 17.935C13.2041 17.935 12.8682 17.5991 12.8682 17.185V8.61525C12.8682 8.20115 13.2041 7.86525 13.6182 7.86525C14.0323 7.86525 14.3682 8.20115 14.3682 8.61525V17.185C14.3682 17.5991 14.0323 17.935 13.6182 17.935Z" fill="#f22e57" />
                <path d="M20.168 4.46535H16.2178V3.85545C16.2178 2.79685 15.3838 1.93555 14.3584 1.93555H9.62792C8.60252 1.93555 7.76802 2.79685 7.76802 3.85545V4.46535H3.82812C3.41403 4.46535 3.07812 4.80125 3.07812 5.21535C3.07812 5.62945 3.41403 5.96535 3.82812 5.96535H4.43243L5.19973 18.6089C5.31203 20.5474 6.92333 22.0659 8.86823 22.0659H15.1084C17.0518 22.0659 18.6719 20.5454 18.7969 18.6011L19.5647 5.96545H20.168C20.5821 5.96545 20.918 5.62955 20.918 5.21545C20.918 4.80135 20.5821 4.46535 20.168 4.46535ZM9.26813 3.85545C9.26813 3.62405 9.42973 3.43555 9.62803 3.43555H14.3585C14.5567 3.43555 14.7179 3.62405 14.7179 3.85545V4.46535H9.26822L9.26813 3.85545ZM17.2998 18.5073C17.2256 19.6616 16.2627 20.5659 15.1084 20.5659H8.86823C7.71733 20.5659 6.76323 19.6684 6.69683 18.52L5.93503 5.96535H18.0611L17.2998 18.5073Z" fill="#f22e57" />
              </svg>
            </>
            :
            <>
              <a onClick={() => btnEdit(row)}>Set-up Group</a>
              {/* <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => btnEdit(row)}><path d="M12.4523 4.45177C12.3523 4.35177 12.2223 4.30177 12.0823 4.30177C11.9523 4.30177 11.8223 4.35178 11.7323 4.44178L0.962305 14.8818C0.772305 15.0718 0.652305 15.3318 0.652305 15.6018L0.612305 17.9818C0.612305 18.5418 1.0523 19.0118 1.6123 19.0118L3.9923 19.0518H4.01231C4.27231 19.0518 4.5323 18.9518 4.7223 18.7618L15.4923 8.32178C15.6923 8.12178 15.7023 7.80177 15.5023 7.60178L12.4523 4.45177Z" fill="#757676"></path><path d="M19.1023 3.42178L16.7323 0.981775C16.5323 0.781775 16.2723 0.681775 16.0123 0.681775L16.0223 0.671875C15.7723 0.671875 15.5223 0.761875 15.3223 0.951875L13.1323 3.07187C12.9423 3.25187 12.9323 3.56187 13.1223 3.75187L16.2123 6.94188C16.3023 7.04188 16.4323 7.09188 16.5623 7.09188C16.6923 7.09188 16.8023 7.04187 16.8923 6.95187L19.0823 4.83187C19.4823 4.45187 19.4923 3.81178 19.1023 3.42178Z" fill="#757676"></path></svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"></svg> */}
            </>
        )
      },
      text: 'Action',
      sort:true,
    },
  ]);


  const defaineShowModal = (flag: any) => {
    //console.log('flag', flag);
    if (flag == false) {
      setStatus(0);
      statusDisableShow();
    }
    else {
      statusEnableShow();
      setStatus(1);
    }
  };

  const setDateRangeFun = async (e: any) => {
    setDateRange(e);
    ////console.log("setDateRange ",e)
    const start_date = moment(e[0]).format("yyyy-MM-DD");
    const end_date = moment(e[1]).format("yyyy-MM-DD");
    setStartDate(start_date);
    setEndDate(end_date);
    //console.log("start date ", start_date);
    //console.log("end date ", end_date);
    //await getActivityLog(start_date, end_date, getActivityType, getmodule);
    huntGroupTableget(dateFilter, hoursFilter, start_date, end_date);
  }

  const huntGroupTableget = async (date: any, hours: any, getstartdate: any, getenddate: any) => {
    let _url = API_ROUTE_CONTROLLER.Urmyacccountgethuntgroupdtl;
    // let _body = {
    //   "company_id": login.company_id,
    //   "groupid": 0,
    //   "daterange": 0,//date
    //   "hours_type": hours
    // };
    let _body = {
      "company_id": login.company_id,
      "groupid": 0,
      "daterange": dateFilter,//date
      "hours_type": hoursFilter,
      "from_date": getstartdate,
      "to_date": getenddate,

    };
    await ApiServices.post(_body, _url).then(async (value: any) => {
      //console.log("vaaaluuueee", value);
      if (value) {
        if (value.status === 200 && value.data.status_code === 200) {
          if (value.data.finalresponse.length > 0) {
            setHuntList(value.data.finalresponse);
          } else {
            setHuntList([]);
          }
        }
      }
    })
  }

  useEffect(() => {
    huntGroupTableget(5, 0, "", "");
  }, []);


  const { SearchBar, ClearSearchButton } = Search;

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );
  const [datas, setDataTable] = useState<any>([]);

  const options = {
    paginationSize: 3,
    pageStartIndex: 1,
    alwaysShowAllBtns: true,
    withFirstAndLast: false,
    prePageText: (
      <svg
        width="6"
        height="12"
        viewBox="0 0 6 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.15283 11.6655C4.96143 11.6655 4.76953 11.5923 4.62303 11.4467L0.758329 7.59322C0.332529 7.16842 0.0977298 6.60302 0.0972298 6.00042C0.0967298 5.39782 0.331629 4.83242 0.758329 4.40572L4.62353 0.553223C4.91653 0.261223 5.39163 0.261223 5.68403 0.555223C5.97653 0.848223 5.97553 1.32282 5.68203 1.61572L1.81733 5.46822C1.67523 5.60982 1.59713 5.79932 1.59713 6.00042C1.59713 6.20062 1.67523 6.38912 1.81733 6.53072L5.68253 10.3842C5.97553 10.6772 5.97643 11.1518 5.68403 11.4447C5.53753 11.5922 5.34513 11.6655 5.15283 11.6655Z"
          fill="#757676"
        />
      </svg>
    ),
    nextPageText: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="6"
        height="12"
        viewBox="0 0 6 12"
        fill="none"
      >
        <path
          d="M0.847363 11.6653C0.654963 11.6653 0.462564 11.5921 0.316164 11.4446C0.0236636 11.1516 0.0246635 10.677 0.318163 10.3841L4.18246 6.53165C4.32456 6.39005 4.40266 6.20055 4.40266 5.99945C4.40266 5.79925 4.32456 5.61075 4.18246 5.46915L0.317764 1.61565C0.0247639 1.32265 0.0238637 0.848048 0.316264 0.555148C0.608264 0.261248 1.08336 0.261248 1.37726 0.553148L5.24156 4.40665C5.66736 4.83145 5.90216 5.39685 5.90266 5.99945C5.90316 6.60205 5.66826 7.16745 5.24156 7.59415L1.37686 11.4466C1.23086 11.5921 1.03876 11.6653 0.847363 11.6653Z"
          fill="#757676"
        />
      </svg>
    ),
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "All",
        value: datas.length,
      },
    ],
  };

  const [setnewusers, getNewUsers] = useState('');
  const addnewusers = () => {
    getNewUsers('true');
  }


  const allOptions: any = [
    { value: "1", label: "Active" },
    { value: "0", label: "InActive" },
  ];


  const dateRange: any = [
    { value: "1", label: "Today" },
    { value: "2", label: "Yesterday" },
    { value: "3", label: "Last 7 days" },
    { value: "4", label: "Last 14 days" },
    { value: "5", label: "Last 30 days" },
    { value: "6", label: "Custom Date" }
  ];

  const hour = [
    { value: '0', label: 'All Hours' },
    { value: '1', label: 'Open Hours' },
    { value: '2', label: 'Closed Hours' }
  ]


  const cliock = () => {
    setIsClicked(!isClicked);
  }


  const dateRangeFilter = (e: any) => {
    //console.log('date', e.value);
    setDateFilter(e.value);
    //const getData = e.map(x => x.value);
    ////console.log("getData", getData.toString());
    // setDateFilter(getData.toString());
    // huntGroupTable(getData.toString(), 0);
    huntGroupTableget(dateFilter, hoursFilter, getstartdate, getenddate);
  }


  const hoursFilterAll = (e: any) => {
    //console.log('hour-', e.value);
    //const getHours = e.map(x => x.value);
    //setHoursFilter(getHours.toString());
    setHoursFilter(e.value);
    huntGroupTableget(dateFilter, hoursFilter, getstartdate, getenddate);
  }


  const Option = (props: any) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };


  const btnEnableAll = async () => {
    if (isSelect == false) {
      alert("Please select atleast one");
    } else {
      const _res = await bulkAction(1, 1, bulkgrpid);
      enablehandClose();
      window.location.reload();

    }
  };

  const btnDisableAll = async () => {
    if (isSelect == false) {
      alert("Please select atleast one");
    } else {
      const _res = await bulkAction(1, 2, bulkgrpid);
      disablehandClose();
      window.location.reload();
    }
  };

  const btnDeleteAll = async () => {
    if (isSelect == false) {
      alert("Please select atleast one");
    } else {
      const _res = await bulkAction(2, 0, bulkgrpid);
      deletehandClose();
      window.location.reload();
    }
  };

  const bulkAction = async (process_type:any, status:any, _checkedUsernames:any) => {
    let _url = API_ROUTE_CONTROLLER.Urmyaccountbulkenabledelete;
    let _body = {
      "company_id": _login.company_id,
      "groupid_info": _checkedUsernames,
      "processtype": process_type,
      "status": status
    };
    const bulkAc = await ApiServices.post(_body, _url).then(async (value: any) => {
      //console.log("bulkAction", value);
      if (process_type == 2 && status == 0) {
        const _body2 = {
          'hunt_group_deleted': "Yes"
          //'hunt_group_name': e.grp_name
        };
        const _res2 = await MarketingServices.post(_body2, "companies", _login.Hubspot_company_id);
      }

    })
    return bulkAc;
  }




  const selectRow = {
    mode: 'checkbox',
    clickToSelect: false,
    onSelect: (row: any, isSelect: any, rowIndex: any, e: any) => {
      //console.log("row ", rowIndex);
      setisSelect(isSelect);
      // handleChange(row);
      if (isSelect) {
        let temp: any = selectedRows;
        //console.log("selectedRowsselectedRows", temp);
        setToastHide(temp);
        temp.push(row);
        setSelectedRows(temp);
        setCreateGroup(true);
        //console.log("getids_ ", selectedRows.map((selectedRows: any) => selectedRows.grp_id).toString());
        bulkGroupid(selectedRows.map((selectedRows: any) => selectedRows.grp_id).toString())



      } else {
        let temp: any = selectedRows;
        //console.log("selectedRows", selectedRows);
        for (let k = 0; k < temp.length; k++) {
          if (temp[k].grp_id == row.grp_id) {
            temp.splice(k, 1);
            break;
          }
        }
        setSelectedRows(temp);
        if (temp.length == 0) {
          setCreateGroup(false);
        }

        //console.log("getids_11 ", selectedRows.map((selectedRows: any) => selectedRows.grp_id).toString());

        bulkGroupid(selectedRows.map((selectedRows: any) => selectedRows.grp_id).toString())

      }

    },
    onSelectAll: (isSelect: any, rows: any, e: any) => {
      //console.log("rows ", rows);
      if (isSelect) {
        setSelectedRows(rows);
        setLength(rows.length);
        setCreateGroup(true);
      } else {
        setSelectedRows([]);
        setLength(0);
        setCreateGroup(false);
      }
      //console.log("getids_ ", selectedRows.map(selectedRows => selectedRows.grp_id).toString());

      bulkGroupid(selectedRows.map((selectedRows: any) => selectedRows.grp_id).toString())

    }
  };

  const hubspot_hunt_status_update=async(process_type:any,status_type:any,name:any)=>{
    let status:any,body:any;
    if(process_type==1) {
      if(status_type==1) {
        status = "Enable";
      } else {
        status = "Disable";
      }
      body = {
        'hunt_group_status':status,
        'hunt_group_name':name,
        'hunt_group_call_redirected':""
      }

    } else {
      body = {
        'hunt_group_deleted':'Yes',
        'hunt_group_name':name,
      }
    }
    await bs.hubspot(body, "companies", login.Hubspot_company_id,"PATCH");   
  };

  const enableStatusSave = async () => {
    setLoader(true);
    let _url = API_ROUTE_CONTROLLER.Urmyaccountbulkenabledelete;
    let _body = {
      "company_id": _login.company_id,
      "groupid_info": grpStatus,
      "processtype": 1,  // (1-Update status,2-Delete)
      "status": status, // (1-Enable,0-disable)
    };
    await ApiServices.post(_body, _url).then(async (value: any) => {
      if (value.data.finalresponse?.length > 0 && value.data.finalresponse[0].errmsg == "Success to update") {
        await hubspot_hunt_status_update(1,1,grpname);
        statusEnableClose();
        setLoader(false);
        window.location.reload();
      }
      else {
        setLoader(false);
      }
    })
  };


  const disableStatusSave = async () => {
    setLoader(true);
    let _url = API_ROUTE_CONTROLLER.Urmyaccountbulkenabledelete;
    let _body = {
      "company_id": _login.company_id,
      "groupid_info": grpStatus,
      "processtype": 1,  // (1-Update status,2-Delete)
      "status": status, // (1-Enable,0-disable)
    };
    await ApiServices.post(_body, _url).then(async (value: any) => {
      if (value.data.finalresponse?.length > 0 && value.data.finalresponse[0].errmsg == "Success to update") {
        await hubspot_hunt_status_update(1,0,grpname);
        statusEnableClose();
        setLoader(false);
        window.location.reload();
      }
      else {
        setLoader(false);
      }
    })
  };

  const gotoPurchase = () => {
    // window.location.href = '/purchase';
    navigate("/purchase");
  };


  return (
    <>
      <ToolkitProvider keyField="grp_id" data={huntList} columns={columns} search={{ defaultSearch: '' }} exportCSV>
        {(props: any) => (
          <>
            <div className={styles.toplayers}>
              <div className={styles.rights}>
                <div className="searchclear">
                    <SearchBar {...props.searchProps} />
                    <ClearSearchButton { ...props.searchProps } className="clears" />
                </div>
                {/* <h5 onClick={() => cliock()}>Advanced Filter <svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="black"></path></svg></h5> */}
                {/* <Select  menuShouldScrollIntoView={false} options={huntfilter} className="regularselect filterwidth" /> */}
              </div>
              <div className={styles.lefts}>
                <button className="successbtn" onClick={gotoPurchase}>Purchase Add-on</button>
              </div>
            </div>
            {
              isClicked == true ?
                <Row>
                  <Col sm={12}>
                    <div className={styles.searchresult}>
                      {/* <MultiSelect className="regularselect" options={allOptions} value={dateFilter} onChange={dateRangeFilter} labelledBy="Status" /> */}
                      <Select menuShouldScrollIntoView={false} className="regularselect" options={dateRange} onChange={dateRangeFilter} placeholder="Select Date Range" />
                      <Select menuShouldScrollIntoView={false} className="regularselect" options={hour} onChange={hoursFilterAll} placeholder="Select Hours Type" />
                      {(dateFilter == 6) ? <><DatePicker
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        // onChange={(update) => {
                        //   setDateRange(update);
                        // }}
                        onChange={(update) => {
                          setDateRangeFun(update);
                        }}
                        placeholderText="Choose Date"
                        isClearable={true}
                      /></> : ""}

                    </div>
                  </Col>
                </Row> : ""
            }
            {/* <Row className={styles.toplayers}>
              <Col sm={8} className={styles.rights}>
                <div className={styles.filterdropdown}>
                  <Select  menuShouldScrollIntoView={false} placeholder="Date Range"
                    className='regularselect'
                    options={dateRange}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      //MultiValue
                      Option
                    }}
                    onChange={(options) => {
                      if (Array.isArray(options)) {
                        setSelectedOptions(options.map((opt: any) => opt.value));
                      }
                    }}
                  />

                  <Select  menuShouldScrollIntoView={false} placeholder="Queue"
                    className='regularselect'
                    options={hour}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      //MultiValue
                      Option
                    }}
                    onChange={(options) => {
                      if (Array.isArray(options)) {
                        setSelectedOptions(options.map((opt: any) => opt.value));
                      }
                    }}
                  />
                </div>
              </Col>
            </Row> */}
            <div className={`desktopmobile ${styles.tablecontainer}`}>
                {/* <BootstrapTable {...props.baseProps} pagination={paginationFactory(options)} /> */}
                <BootstrapTable {...props.baseProps} selectRow={selectRow} noDataIndication={
                      <div className='emptyDataInTable'>
                        <img src={EmptyData} alt="img"></img>
                        <p>No data found</p>
                      </div>
                    } pagination={paginationFactory(options)} />
            </div>
            <div className={`mobiletable  ${styles.tablecontainer}`}>
                {/* <BootstrapTable {...props.baseProps} pagination={paginationFactory(options)} /> */}
                <BootstrapTable {...props.baseProps}  pagination={paginationFactory(options)} expandRow={expandRow} noDataIndication={
                      <div className='emptyDataInTable'>
                        <img src={EmptyData} alt="img"></img>
                        <p>No data found</p>
                      </div>
                    }
                        keyField='date'/>
            </div>
          </>
        )}
      </ToolkitProvider>


      {/* Delete popup */}
      <Modal show={modalShow} onHide={handleClose} className="modaldefaults" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>security policy
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modalbigspace'>
          <p>Are you sure to delete the role Test 01</p>
          <label className={styles.fieldarea}>
            <span>Field Name <sub>*</sub></span>
            <input type="" name="field_name" placeholder='Text Field' />
          </label>
          <label className={styles.fieldarea}>
            <span>Description<sub>*</sub></span>
            <div className={styles.textareafield}>
              <textarea name="first_name" placeholder="Description" />
            </div>
          </label>
        </Modal.Body>

        <Modal.Footer>
          <button onClick={handleClose} className="cancelbtn">Cancel</button>
          <button className="">Create Security policy</button>
        </Modal.Footer>
      </Modal>


      {/* enable popup */}
      <Modal show={enableShow} onHide={enablehandClose} className="modaldefaults" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Enable selected hunt group(s)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modalbigspace'>
          <p>Are you sure you want to enable selected hunt group(s)?</p>
        </Modal.Body>

        <Modal.Footer>
          <button className="cancelbtn" onClick={enablehandClose}>Cancel</button>
          <button className="newgreen" onClick={btnEnableAll}>Confirm</button>
        </Modal.Footer>
      </Modal>

      {/* disable popup */}
      <Modal show={disableShow} onHide={disablehandClose} className="modaldefaults" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Disable selected hunt group(s)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modalbigspace'>
          <p>Default settings will be applied to the <span className='highlight'>Play a greeting</span> and <span className='highlight'>Route to options</span> for the selected hunt group(s).</p>
          <p>Are you sure you want to disable selected hunt group(s)?</p>
        </Modal.Body>

        <Modal.Footer>
          <button className="cancelbtn" onClick={disablehandClose}>Cancel</button>
          <button className="newgreen" onClick={btnDisableAll}>Confirm</button>
        </Modal.Footer>
      </Modal>

      {/* Delete popup */}
      <Modal show={deleteShow} onHide={deletehandClose} className="modaldefaults" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete selected hunt group(s)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modalbigspace'>
          <p>Deleting the selected group(s) will delete all the current settings and new group should be created.</p>
        </Modal.Body>

        <Modal.Footer>
          <button onClick={deletehandClose} className="cancelbtn">Cancel</button>
          <button className="newgreen" onClick={btnDeleteAll}>Confirm</button>
        </Modal.Footer>
      </Modal>



      <Modal show={statusEnable} onHide={statusEnableClose} className="modaldefaults" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Enable selected hunt group?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modalbigspace'>
          <p>Calls will be routed to the selected hunt group based on settings. Please confirm to proceed.</p>
        </Modal.Body>

        <Modal.Footer>
          <button onClick={statusEnableClose} className="cancelbtn">Cancel</button>
          <button className="newgreen" onClick={enableStatusSave}>Confirm</button>
        </Modal.Footer>
      </Modal>

      <Modal show={statusDisable} onHide={statusDisableClose} className="modaldefaults" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Disable selected hunt group?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modalbigspace'>
          <p>Calls will be routed to the selected hunt group based on settings. Please confirm to proceed.</p>
        </Modal.Body>

        <Modal.Footer>
          <button onClick={statusDisableClose} className="cancelbtn">Cancel</button>
          <button className="newgreen" onClick={disableStatusSave}>Confirm</button>
        </Modal.Footer>
      </Modal>








      {selectedRows.length > 0 ?
        <Row className="bulkselection">
          <Col sm={12}>
            <p><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0604 9.50017L17.7008 1.85957C17.9938 1.56657 17.9938 1.09197 17.7008 0.799074C17.4078 0.506174 16.9332 0.506074 16.6403 0.799074L8.99987 8.43967L1.35947 0.798974C1.06647 0.505974 0.591874 0.505974 0.298974 0.798974C0.00607365 1.09197 0.00597364 1.56657 0.298974 1.85947L7.93937 9.50007L0.298974 17.1407C0.00597364 17.4337 0.00597364 17.9083 0.298974 18.2012C0.445474 18.3477 0.637374 18.4209 0.829274 18.4209C1.02117 18.4209 1.21307 18.3477 1.35957 18.2012L8.99997 10.5606L16.6404 18.2012C16.7869 18.3477 16.9788 18.4209 17.1707 18.4209C17.3626 18.4209 17.5545 18.3477 17.701 18.2012C17.994 17.9082 17.994 17.4336 17.701 17.1407L10.0604 9.50017Z" fill="white" />
            </svg> {selectedRows.length} Hunt Groups selected</p>
            <ul className="menulists">
              <li onClick={enablehandShow}>Enable</li>
              <li onClick={disablehandShow}>Disable</li>
              <li className="deleteli" onClick={deletehandShow}>Delete</li>
            </ul>
          </Col>
        </Row>
        : <></>}

      {/* Toast */}

      {loader && <Loaders></Loaders>}

    </>
  );
};

export default HuntGroupTable;
